<template>

    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title">잠시 기다려주세요...</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body text-center">

        <h5 class="mt-5 text-primary2">모두싸인에서의 작업이 종료될때 까지 기다리고 있습니다</h5>
        <h6 class="mt-3 mb-5 text-info">작업을 완료하지 않고 모두싸인창을 닫으셨으면 X로 닫으면 됩니다.</h6>

      </div>
    </div>

</template>

<script>
import { mapState } from 'vuex'

export default {
}
</script>